<template>
  <wt-selector class="agent-selector" ref="select" :multiple="multiple" :options="options" v-model="Value" clearable="true" :disabled="disabled" :filterable="filterable"></wt-selector>
  <!-- <el-select v-model="Value" :multiple="multiple" :clearable="true" :disabled="disabled">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
    </el-option>
  </el-select> -->
</template>
<script>
export default {
  name: 'agent-selector',
  props: {
    value: {
      type: [Array, String]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
		filterable:{
			type:Boolean,
			default:false
		}
  },
  data () {
    return {
      Value: this.value,
      options: [],
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getList () {
      let data = {
        example:{
        },
        pageable: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getOrganizationsList',data).then(res => {
        this.options = res.data.map(e=>{
          return{
            label:e.base?.name || '-',
            value:e.id
          }
        })
      }).catch(err => {
        this.$message.error(err || '获取客户列表失败')
      })
    },
  },
  created () {
    this.getList()
  }
}
</script>
<style lang="less">
  .agent-selector {

    .el-input,
    .el-input__inner {
      height: .4rem !important;
    }
  }
</style>
